export default {
  insertMenuTitle: 'Ausdrucksmenü',
};
